import { createContext, useContext, useState, useEffect } from 'react';

const FeatureContext = createContext({});

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULTS = {
  registration: true,
  guest_mode: false,
  playback_speed: true,
  loop_repeat: true,
  favorites: true,
  listening_stats: true,
};

export function FeatureProvider({ children }) {
  const [features, setFeatures] = useState(DEFAULTS);

  useEffect(() => {
    fetch(`${API_URL}/api/feature-toggles`)
      .then(r => r.ok ? r.json() : DEFAULTS)
      .then(data => setFeatures({ ...DEFAULTS, ...data }))
      .catch(() => {});
  }, []);

  return (
    <FeatureContext.Provider value={features}>
      {children}
    </FeatureContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeatureContext);
}
